import gql from 'graphql-tag';
import {fragments as mapHitFragments} from '../MapHit/MapHit';

const mapFragments = {
    SearchResult: gql`
        fragment MapSearchResult on SearchResult {
            mapViewport {
                neLat
                neLong
                swLat
                swLong
            }
            page
            pageSize
            listings {
                ...MapHitListing
            }
            pinnedListing {
                listing {
                    ...MapHitListing
                }
            }
        }
        ${mapHitFragments.Listing}
    `
};

export {mapFragments};
